import { Select } from 'antd'
import { checkRole } from '../../../../../helpers/helpers'
import { roles } from '../../EditTeamMember/Form/form'

export const complianceInputs = (store, errors, showFields) => [
  {
    key: 0,
    name: 'member_type',
    label: 'Role',
    type: 'select',
    customOptions: roles.map(
      (item) =>
        checkRole(
          [store.user?.[0]?.member_type],
          item.roles_that_can_change_current_role
        ) && (
          <Select.Option key={item.key} value={item.value}>
            {item.name}
          </Select.Option>
        )
    ),
    placeholder: 'Select Role',
    validation: { required: true },
    error: errors && errors.member_type && 'Select Role',
  },
  {
    key: 1,
    name: 'topics',
    label: 'Assign By Topic',
    type: 'multiSelect',
    options: store.topicsMembers,
    placeholder: 'All Topics in My Plan',
    validation: { required: false },
    error: errors && errors.topics && 'This field is required',
    transparent: true,
    loading: !store.topicsMembers.length,
    style: { marginBottom: errors && errors.topics && '0' },
    showFields,
  },
  {
    key: 2,
    name: 'jurisdictions',
    label: 'Assign By Jurisdiction',
    type: 'multiSelect',
    options: store.jursMembers,
    placeholder: 'All Jurisdictions in My Plan',
    validation: { required: false },
    error: errors && errors.jurisdictions && 'This field is required',
    transparent: true,
    loading: !store.jursMembers.length,
    style: { marginBottom: errors && errors.jurisdictions && '0' },
    showFields,
  },
  {
    key: 3,
    name: 'line_of_business',
    label: 'Assign By Line of Business',
    type: 'multiSelect',
    options: store.lineOfBusinessesMembers,
    placeholder: 'All Lines of Business',
    validation: { required: false },
    error: errors && errors.line_of_business && 'This field is required',
    transparent: true,
    loading: !store.lineOfBusinessesMembers.length,
    style: { marginBottom: errors && errors.line_of_business && '0' },
    showFields:
      showFields && store?.company?.length > 0 && store.company[0].is_premium,
  },
]

export const resourceInputs = (store, errors, showFields) => [
  {
    key: 0,
    name: 'resource_role',
    label: 'Role',
    type: 'select',
    customOptions: roles
      .filter((item) => item.key !== 'compliance_owner')
      .map(
        (item) =>
          checkRole(
            [store.user?.[0]?.member_type],
            item.roles_that_can_change_current_role
          ) && (
            <Select.Option key={item.key} value={item.value}>
              {item.name}
            </Select.Option>
          )
      ),
    placeholder: 'Select Role',
    validation: { required: true },
    error: errors && errors.resource_role && 'Select Role',
  },
  {
    key: 2,
    name: 'resource_guides',
    label: 'Assign By Guides',
    type: 'multiSelect',
    options: store.resources,
    placeholder: 'All Guid in My Plan',
    validation: { required: false },
    error: errors && errors.topics && 'This field is required',
    transparent: true,
    loading: !store.resources?.length,
    style: { marginBottom: errors && errors.topics && '0' },
    showFields,
    selectVars: { value: 'guide_name_id' },
  },
  {
    key: 3,
    name: 'resource_jurisdictions',
    label: 'Assign By Jurisdiction',
    type: 'multiSelect',
    options: store.selectedJurisdictions,
    placeholder: 'All Jurisdictions in My Plan',
    validation: { required: false },
    error: errors && errors.jurisdictions && 'This field is required',
    transparent: true,
    loading: !store.selectedJurisdictions,
    style: { marginBottom: errors && errors.jurisdictions && '0' },
    showFields,
  },
]
